import { render, staticRenderFns } from "./provision.vue?vue&type=template&id=3987e669&"
import script from "./provision.vue?vue&type=script&lang=js&"
export * from "./provision.vue?vue&type=script&lang=js&"
import style0 from "./provision.vue?vue&type=style&index=0&id=3987e669&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports